import { updateWorkspace } from '@usehatchapp/javascript-sdk';
import { SET_FRESH_ORGANIZATION_KEY } from 'root/stores/fresh';
import {
  ORGANIZATION_BOARDS,
  ORGANIZATION_TEAM,
} from 'root/stores/fresh/schema';
import { call } from 'utils/call';

import { constants } from '../constants';

export const doUpdateBoard =
  ({ boardId, organizationId, data, workspaceId } = {}, callback) =>
  async ({ dispatch, request }) => {
    const { UPDATE_BOARD_FAILURE, UPDATE_BOARD_REQUEST, UPDATE_BOARD_SUCCESS } =
      constants;

    try {
      // tell state we're fetching board
      dispatch({ type: UPDATE_BOARD_REQUEST });

      // create board
      const { name, forwardTo, teamMemberIDs, timezone, nickname, email } =
        data;
      const updateBody = {
        email,
        forward_to: forwardTo,
        name,
        nickname,
        team_member_ids: teamMemberIDs,
        timezone: {
          observes_daylight_savings: timezone.observesDaylightSavings,
          offset_hours: timezone.offsetHours,
        },
      };

      await request(updateWorkspace, {
        data: updateBody,
        workspaceId,
      });

      // Trigger fetches for team and boards via reaction
      dispatch({
        actions: [
          {
            type: UPDATE_BOARD_SUCCESS,
          },
          {
            payload: {
              fresh: false,
              key: ORGANIZATION_BOARDS,
              organizationIDs: [organizationId],
            },
            type: SET_FRESH_ORGANIZATION_KEY,
          },
          {
            payload: {
              fresh: false,
              key: ORGANIZATION_TEAM,
              organizationIDs: [organizationId],
            },
            type: SET_FRESH_ORGANIZATION_KEY,
          },
        ],
        type: 'BATCH_ACTIONS',
      });
      dispatch({
        actionCreator: 'doCreateNotificationMessage',
        args: [{ message: 'Successfully updated workspace!', type: 'success' }],
      });

      // call the callback with no error and validated board response
      call(callback)(null, { boardId, data });
    } catch (error) {
      call(callback)(error);
      dispatch({ error, type: UPDATE_BOARD_FAILURE });
    }
  };
